import React, { useEffect } from 'react'
import { useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom'
import PerfectScrollbar from "react-perfect-scrollbar"
import BreadcrumbHeader from '../../../layout/BreadcrumbsHeader'
import StartupDetailSkeleton from './StartupDetailSkeleton';
import { SECONDARY, WHITEBG } from '../../../ui-components/CustomButton'
import { useTheme } from '@emotion/react'
import ThemeBGWrapper from '../../../ui-components/ThemeBGWrapper'
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Box, Card, CircularProgress, Grid, Tab, Tabs, Typography, IconButton, Tooltip } from '@mui/material'
import { makeStyles } from "@mui/styles"
import RoundInformation from './RoundInformation'
import { ReactComponent as InfoIcon } from '../../../assets/help-circle.svg';
import CustomTabs from '../../../ui-components/CustomTabs'
import { containerRef, dealFlowStatuses, delayHoursForView, getLastViewedAt, handleCopyClick, hasPermission, setLastViewedAt } from '../../../utils'
import { ContentCopyOutlined, FileCopy, OpenInNew } from '@mui/icons-material'
import NeedHelpButton from 'ui-components/NeedHelpButton'
import RoundDocuments from './RoundDocuments'
import StartupInformation from './StartupInformation'
import { ChangeStatusForCurrentPipeline, FetchPipelinesStatuses, FetchPipelineStatus, FetchRoundViewDetails, FetchViewStartupDetails, SaveView } from 'api/startup_applications'
import Cookies from 'js-cookie'
import moment from 'moment'
import ManageNotes from './ManageNotes'
import SubmitFeedback from './SubmitFeedback'
import Reports from './Reports'
import Performance from './Performance'
import { useSelector } from 'react-redux'
import StartupStatusSelector from 'ui-components/StartupStatusSelector'
import { useToast } from 'context/ToastContext'
import { useInvestorViewTracking } from '../../../hooks/useInvestorViewTracking'
import { useViewSession } from '../../../hooks/useEngagementTracking'

const useStyles = makeStyles((theme) => ({
    scrollTabs: {
        '& > .Mui-disabled.MuiTabs-scrollButtons': {
            display: 'none',
            transition: 'all 1s ease'
        }
    }
}));

const InvestorActions = () => {
    // console.log("Statuas")
    return <Typography>Status</Typography>
}

const ViewDetails = () => {
    const investor_id = Cookies.get("X-INV-ID") || null;
    const { tab: tabValue } = useParams();
    const theme = useTheme()
    const [windowWidth, setWindowWidth] = React.useState(
      typeof window !== "undefined" ? window.innerWidth : 0
    );
    const [resizeTrigger, setResizeTrigger] = React.useState(0);
    const navigate = useNavigate();
    const isSmallScreen = windowWidth <= theme.breakpoints.values.sm;
    const isLargeScreen = windowWidth >= theme.breakpoints.values.md;
    const classes = useStyles();
    const userPermissions = useSelector((state) => state?.permissions?.userPermissions);

    React.useEffect(() => {
      const handleResize = () => {
        setWindowWidth(window.innerWidth);
        setResizeTrigger((prev) => prev + 1);
      };

      handleResize();
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }, []);
    const cookieStartupId = Cookies.get("startup_id");

    useInvestorViewTracking(cookieStartupId, investor_id, tabValue, resizeTrigger);
    // Runs alongside the 24h-throttled view above: that one feeds the existing
    // viewer table, this one records the visit and its duration for the
    // founder's Key Metrics.
    useViewSession(cookieStartupId, investor_id);
    const Actions = () => {
        return (
            <>
                <NeedHelpButton />
            </>
        );
    };

    const [searchParams, setSearchParams] = useSearchParams();
    const { mutateAsync: fetchStatusesData, isLoading: isLoadingStatuses } =
        FetchPipelinesStatuses({ investor_id: investor_id });

    const [openMoveToDealFlow, setOpenMoveToDealFlow] = React.useState(false);
    const [currentRow, setCurrentRow] = React.useState(null);
    const [pipelineStatusesData, setPipelineStatusesData] = React.useState(null);
    const statusTabsArray = !pipelineStatusesData?.data
    ? [
        
      ]
    : [
        ...pipelineStatusesData?.data,
      ];

    const { addToast } = useToast();
    
      const refetchStatusTabs = React.useCallback(() => {
        fetchStatusesData(
          { investor_id },
          {
            onSuccess: (response) => {
              setPipelineStatusesData({
                data:
                  response?.data?.data?.map((item) => {
                    return {
                      ...item,
                      mappedValue: item?.value,
                      label: item?.status,
                      value: item?._id,
                      display_order: item?.display_order,
                    };
                  }) || [],
              });
            },
            onError: (response) => {
              // console.log(response, "response")
            },
          }
        );
      }, [investor_id, fetchStatusesData]);
    
      React.useEffect(() => {
        refetchStatusTabs();
      }, [investor_id]);

        const {
          isLoading: isChangingStatusForCurrentPipeline,
          mutateAsync: changeStatusForCurrentPipelineAsync,
        } = ChangeStatusForCurrentPipeline();
    let startup_id = searchParams.get("startup_id");

    let roundTabs = [];

    const [value, setValue] = React.useState(tabValue ? tabValue : "view-profile");

    const { data: startupDetails, isLoading: isLoadingStartupDetails, refetch: refetchStartupDetails } = FetchViewStartupDetails(cookieStartupId)
    let {
        data: pipeline_details,
        isLoading: isLoadingStatus,
        refetch: refetchStartupStatus,
        status: pipeline_status
    } = FetchPipelineStatus({
        id: cookieStartupId, investor_id
    })

    const { mutateAsync: SaveViewAsync } = SaveView();

    const saveView = React.useCallback((startup_id) => {
        SaveViewAsync({ startup_id, investor_id, view_type: "startup_profile" })
            .then(response => {
                if (response?.data?.investorInfo?.statusCode == 200) {
                    setLastViewedAt(investor_id, startup_id)
                }
            })
            .catch(err => {
                addToast(err?.response?.data?.message, "error")
            });
    }, [SaveViewAsync, investor_id, addToast])

    React.useEffect(() => {
        const viewedStartupId = startupDetails?.data?._id
        if (!viewedStartupId || !investor_id) return;

        const lastView = getLastViewedAt(investor_id, viewedStartupId)
        if (lastView != null) {
            const hours = moment().diff(moment(lastView), 'hours');
            if (hours >= delayHoursForView) {
                saveView(viewedStartupId)
            }
        } else {
            saveView(viewedStartupId)
        }
    }, [startupDetails?.data?._id, investor_id])

    const [selectedStartupStatus, setSelectedStartupStatus] = React.useState(null)

    React.useEffect(() => {
        if(pipeline_details){
            setSelectedStartupStatus({ pipeline_id: pipeline_details?.pipeline_id, status: pipeline_details?.investor_status_id })
        }
    },[pipeline_details])

    const handleCloseMoveToDealFlow = () => {
    setOpenMoveToDealFlow(false);
    setCurrentRow(null);
  };
  
    const handleMoveToSelectedStatus = React.useCallback(
          (props) => {
      
            const constants = {
              investor: "investor",
              rejected: "rejected",
            };
      
            const isRejected =
              statusTabsArray.find(
                (item) => item?.value === props?.payload?.investor_status_id
              )?.mappedValue === constants["rejected"];
      
            const mappedValue = statusTabsArray?.find(
              (item) => item?.value === props?.payload?.investor_status_id
            )?.mappedValue;
      
            const payload = {
              investor_status_id: props?.payload?.investor_status_id,
              ...(isRejected ? { rejected_by: constants["investor"] } : {}),
              ...(mappedValue ? { status: mappedValue } : { status: "in-progress" }),
            };
      
            changeStatusForCurrentPipelineAsync(
              { payload: payload, pipeline_id: props?.payload?.pipeline_id },
              {
                onSuccess: (successResponse) => {
                  if (successResponse?.data?.statusCode === 200) {
                    // setValue(props?.payload?.investor_status_id);
                    // refetchStartupStatus();
                    // handleCloseMoveToDealFlow();
                    setSelectedStartupStatus({
                        ...pipeline_details,
                        status: props?.payload?.investor_status_id
                    })
                  }
                },
                onError: (errorResponse) => {
                  addToast(errorResponse?.response?.data?.message, "error");
                },
              }
            );
          },
          [
            investor_id,
            // currentRow?.pipeline_id,
            pipeline_details?.pipeline_id,
            changeStatusForCurrentPipelineAsync,
            addToast,
            // handleCloseMoveToDealFlow,
          ]
    );

    const handleChange = (event, newValue) => {
        setValue(newValue);

        navigate("/deal-flow/" + newValue, { replace: true });

        // setSearchParams({ page: newValue })

        // navigate(`/startups/view?page=${}`)
        refetchStartupDetails();
    };

    const [copied, setCopied] = React.useState(false)

    React.useEffect(() => {
        if (cookieStartupId) {
            if (startup_id?.trim()?.length > 0 && startup_id !== null) {
            Cookies.set("startup_id", startup_id);
            navigate(`/deal-flow/${value}`, { replace: true })
            }
        } else if (startup_id?.trim()?.length > 0 && startup_id !== null) {
            Cookies.set("startup_id", startup_id);
            navigate(`/deal-flow/${value}`, { replace: true })
        } else {
            navigate(-1); // Navigate back if no valid startup_id
        }
    }, [cookieStartupId, startup_id, setSearchParams, navigate, searchParams]);

    const backrrPermissionCookie = Cookies.get("permissions") || null;

    const manage_notes = window.location?.pathname?.includes("backrr_startups") ?
        [{
            label: "Matched Investors",
            // icon: RoundInvestorsIcon,
            value: "matched_investors",
            permission: backrrPermissionCookie && JSON.parse(backrrPermissionCookie)?.backrr_startups
        },
        {
            label: "Admin Notes",
            // icon: RoundDocumentsIcon,
            value: "admin_notes",
            permission: backrrPermissionCookie && JSON.parse(backrrPermissionCookie)?.backrr_startups
        }] : [{
            label: "Notes",
            value: "view-notes",
            permission: hasPermission("startups", "manage_internal_notes", userPermissions)
        }]

    const round_details_visible = pipeline_details?.startup_round_id ? [
        {
            label: "Round Details",
            // icon: RoundInvestorsIcon,
            value: "view-round",
            permission: hasPermission("startups", "view", userPermissions)
        },
    ] : []

    roundTabs = [
        {
            label: "Profile",
            // icon: RoundDetailsIcon,
            value: "view-profile",
            permission: hasPermission("startups", "view", userPermissions)
        },
        ...round_details_visible,
        {
            label: "Documents",
            // icon: RoundDocumentsIcon,
            value: "view-documents",
            permission: hasPermission("startups", "view", userPermissions)
        },
        {
            label: "Reports",
            // icon: RoundDocumentsIcon,
            value: 'view-reports',
            permission: hasPermission("startups", "view", userPermissions) && hasPermission("reports", "view", userPermissions)
        },
        {
            label: "Performance",
            // icon: RoundDocumentsIcon,
            value: "view-performance",
            permission: hasPermission("startups", "view", userPermissions)
        },
        {
            label: "Feedback",
            // icon: RoundDocumentsIcon,
            value: "view-feedback",
            permission: hasPermission("startups", "submit_feedback", userPermissions)
        },
        ...manage_notes
    ]


    const hasPermissionForTab = ({ current_tab }) => {
        return roundTabs?.filter(tab => tab?.permission === true)?.find(item => item?.value === current_tab)?.permission
    }

    const StartupName = (data) => <>
        {data?.startup_name} <Tooltip title="View Profile">
            <IconButton
                onClick={() => window.open(startupDetails?.data?.backrr_base_url, '_blank')}
            >
                <OpenInNew sx={{ height: 25 }} />
            </IconButton>
        </Tooltip>
        {/* <StartupStatusSelector 
            startupId={cookieStartupId} 
            statuses={pipelineStatusesData?.data} 
            selectedStartupData={selectedStartupStatus}  
            //refetchListing={refetchStartupDetails} 
            handleSubmit={handleMoveToSelectedStatus}

             customSx=
             {{
                    left: {
                        // xs: "10rem",    // mobile
                        sm: "17rem !important",    // small tablet
                        md: "20.5rem !important",  // laptop (>= 900px)
                        // lg: "20.5rem",  // large screens
                    }
            }}
        /> */}
    </>

    return (
        <ThemeBGWrapper>
            <BreadcrumbHeader title={() => <Box display={"flex"} alignItems={"center"}>
                <>{
                    isLoadingStartupDetails
                        ? "Loading..."
                        :
                        isSmallScreen
                            ? "View Details"
                            : StartupName(startupDetails?.data)
                                ? StartupName(startupDetails?.data)
                                : "View Details"
                }
                </>

            </Box>} Actions={Actions} sx={{ paddingBottom: "0 !important" }} />
            
            {isLoadingStartupDetails ?
                <Grid item xs={12} sx={{ width: '100%', bgColor: theme.palette.customColors.yellow_bg }}>
                    <StartupDetailSkeleton />
                </Grid>
                : <>
                    <Grid xs={12} container bgColor={theme.palette.customColors.yellow_bg} height={"100%"}>
                        <Box sx={{ width: '100%', typography: 'body1' }}>
                            <TabContext value={value}>
                                <Box px={isSmallScreen ? "1rem" : "2rem"} bgColor={theme.palette.customColors.yellow_bg}>
                                    <CustomTabs data={roundTabs?.filter(tab => tab?.permission === true)} value={value} isSmallScreen={isSmallScreen} className={classes} titleStyle={{ fontSize: '1.10rem' }} handleChange={handleChange} key={"Tabs Tabs"} sx={{ paddingTop: {xs : "0rem", sm: '1rem'} }} bgColor="transparent" />
                                </Box>
                                {hasPermissionForTab({ current_tab: "view-profile" }) && <TabPanel value="view-profile" sx={{ paddingInline: 0, height: '100%' }}>
                                    <PerfectScrollbar containerRef={containerRef} style={{ height: isLargeScreen ? "calc(100vh - 190px)" : "calc(100dvh - 185px)", paddingInline: isSmallScreen ? "1rem" : "2rem" }}>
                                        <StartupInformation data={startupDetails?.data} round_id={"wefrtg"} InvestorActions={InvestorActions} />
                                    </PerfectScrollbar>
                                </TabPanel>}
                                {pipeline_details?.startup_round_id && hasPermissionForTab({ current_tab: "view-round" }) && <TabPanel value="view-round" sx={{ paddingInline: 0, height: '100%' }}>
                                    <PerfectScrollbar containerRef={containerRef} style={{ height: isLargeScreen ? "calc(100vh - 190px)" : "calc(100dvh - 185px)", paddingInline: isSmallScreen ? "1rem" : "2rem" }}>
                                        <RoundInformation data={{}} round_id={pipeline_details?.startup_round_id} />
                                    </PerfectScrollbar>
                                </TabPanel>}
                                {hasPermissionForTab({ current_tab: "view-documents" }) && <TabPanel value="view-documents" sx={{ paddingInline: 0, height: '100%' }}>
                                    <PerfectScrollbar containerRef={containerRef} style={{ height: isLargeScreen ? "calc(100vh - 190px)" : "calc(100dvh - 185px)", paddingInline: isSmallScreen ? "1rem" : "2rem" }}>
                                        <RoundDocuments startup_id={cookieStartupId} startup_slug={startupDetails?.data?.slug} round_id={pipeline_details?.startup_round_id} startup_name={startupDetails?.data?.startup_name} />
                                    </PerfectScrollbar>
                                </TabPanel>}
                                {hasPermissionForTab({ current_tab: "view-notes" }) && <TabPanel value="view-notes" sx={{ paddingInline: 0, height: '100%' }}>
                                    <PerfectScrollbar containerRef={containerRef} style={{ height: isLargeScreen ? "calc(100vh - 190px)" : "calc(100dvh - 185px)", paddingInline: isSmallScreen ? "1rem" : "2rem" }}>
                                        <ManageNotes data={startupDetails?.data} startup_id={cookieStartupId} />
                                    </PerfectScrollbar>
                                </TabPanel>}
                                {hasPermissionForTab({ current_tab: "view-feedback" }) && <TabPanel value="view-feedback" sx={{ paddingInline: 0, height: '100%' }}>
                                    <PerfectScrollbar containerRef={containerRef} style={{ height: isLargeScreen ? "calc(-9.5625rem + 100vh)" : "calc(-9.5625rem + 100dvh)", paddingInline: isSmallScreen ? "1rem" : "2rem" }}>
                                        <SubmitFeedback />
                                    </PerfectScrollbar>
                                </TabPanel>}
                                {hasPermissionForTab({ current_tab: "view-reports" }) && <TabPanel value="view-reports" sx={{ paddingInline: 0, height: '100%' }}>
                                    {/* <PerfectScrollbar containerRef={containerRef} style={{ height: isLargeScreen ? "calc(100vh - 190px)" : "calc(100vh - 185px)", paddingInline: isSmallScreen ? "1rem" : "2rem" }}> */}
                                    <Reports startup_details_id={cookieStartupId} />
                                    {/* </PerfectScrollbar> */}
                                </TabPanel>}
                                {/* padding 0 (not just paddingInline): MUI's TabPanel defaults to 24px, which
                                    startup-web's /performance has no equivalent of — it pushed the Data/Graphs
                                    row below the live's rhythm. Performance sets its own spacing internally. */}
                                {hasPermissionForTab({ current_tab: "view-performance" }) && <TabPanel value="view-performance" sx={{ padding: 0, height: '100%' }}>
                                    {/* <PerfectScrollbar containerRef={containerRef} style={{ height: isLargeScreen ? "calc(100vh - 190px)" : "calc(100vh - 185px)", paddingInline: isSmallScreen ? "1rem" : "2rem" }}> */}
                                    <Performance startup_id={cookieStartupId} />
                                    {/* </PerfectScrollbar> */}
                                </TabPanel>}
                            </TabContext>
                        </Box>
                    </Grid>
                </>
            }
        </ThemeBGWrapper>
    )
}

export default ViewDetails